<template>
  <div class="variants" style="text-align: center">

    <side-icons></side-icons>

    <!-- <transition name="fade">
      <el-row v-if="store.render.VariantFrequency" style="margin-top: 30px;">
        <el-col :xs="{span: 22, offset: 1}" :sm="{span: 22, offset: 1}"
          :md="{span: 20, offset: 1}" :lg="{span: 16, offset: 5}" align="left">
          
          <el-row :style="`color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}; padding-bottom: 30px`">
            <div class="section-header" :style="`color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}; padding-bottom: 20px`">
              Variants
            </div>
            <el-row :style="`color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}; padding-left: 20px`">
              A variant is a change in the genome of the virus.
            </el-row>
          </el-row>
          
          
          <el-row style="background-color: rgba(255, 255, 255, 0.7); border-radius: 3px; padding: 20px">
            <div class="plot-header" style="color: #2e2e2e">
              Mutation Percentage Frequency
            </div>
            <div style="padding-left: 40px; color: #2e2e2e">
              Depending on the effect of the mutation on the virus it is either propogated to further generations
              or is diluted out. The plot below shows the presence of the mutation at a particular genomic position across
              all samples. The frequency of the presence is shown as the percentage of the samples having the particular 
              mutation.
            </div>
            <variant-frequency></variant-frequency>
          </el-row>
        </el-col>
      </el-row>
    </transition> -->

    <!-- <transition name="fade">
      <el-row v-if="store.render.VariantTimeline || store.render.VariantsTable" style="margin-top: 40px">
        <el-col :xs="{span: 22, offset: 1}" :sm="{span: 22, offset: 1}"
            :md="{span: 20, offset: 1}" :lg="{span: 16, offset: 5}" align="center">

          <div :style="`font-size: 1em; margin-right: 15px; font-weight: bold; font-family: 'Hammersmith One', sans-serif;
            color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}; padding-bottom: 10px`">
            SELECT VIEW
          </div>
          <el-radio-group class="variant-tab-view" v-model="tabView" @change="variantSwitchView()">

            <el-radio-button label="Timeline">
              <i class="fas icon-fa-calendar-alt" style="margin-right: 10px"></i>
              Timeline
            </el-radio-button>

            <el-radio-button label="Table" style="font-size: 2em; font-weight: bold">
              <i class="fas icon-fa-table" style="margin-right: 10px"></i>
              Table
            </el-radio-button>

          </el-radio-group>
        </el-col>
      </el-row>    
    </transition> -->


    <!-- <transition name="fade">
      <el-row v-if="store.render.VariantTimeline" style="margin-top: 30px">
        <el-col class="section-header" :style="`text-align: center; color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}`" :span="22" :offset="1">
          Variants Timeline
        </el-col>
        <el-col :span="22" :offset="1" id="variant-state-map" align="center" style="margin-bottom: 30px">
          <variants-timeline></variants-timeline>
        </el-col>
      </el-row>
    </transition> -->

    <transition name="fade">
      <el-row v-loading="!(store.render.VariantsTable)" v-if="store.render.VariantsTable" style="margin-top: 30px; background-color: rgba(0,0,0,0)">
        <el-col :xs="{span: 22, offset: 1}" :sm="{span: 22, offset: 1}"
          :md="{span: 20, offset: 1}" :lg="{span: 16, offset: 5}" class="section-header" :style="`text-align: center; color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}`" :span="22" :offset="1">
          List of catalogued mutations
        </el-col>
        <el-col  :xs="{span: 22, offset: 1}" :sm="{span: 22, offset: 1}"
          :md="{span: 20, offset: 1}" :lg="{span: 16, offset: 5}" id="variant-state-map" align="center" style="margin-bottom: 30px">
          <mutations-table></mutations-table>
        </el-col>
      </el-row>
    </transition>

    <div v-if="store.render.VariantsTable" id="mutation-data">
      <el-row style="margin-top: 30px; min-height: 90vh" v-if="store.mutationComponent.variantData.selectedVariant._id !== undefined">
        <el-col :xs="{span: 22, offset: 1}" :sm="{span: 22, offset: 1}"
          :md="{span: 20, offset: 1}" :lg="{span: 16, offset: 5}" 
          :element-loading-fullscreen="false">
          <mutation-data :key="store.mutationComponent.variantData.selectedVariant._id"></mutation-data>
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
import { store } from '@/scripts/store'

export default {
  name: 'Mutations',
  components: {
    // VariantFrequency: () => import('@/components/plots/VariantFrequency.vue'),
    SideIcons: () => import('@/components/SideIcons.vue'),
    // VariantStateTimeline: () => import('@/components/plots/VariantStateTimeline.vue'),
    // VariantsTimeline: () => import('@/components/plots/VariantsTimeline.vue'),
    MutationsTable: () => import('@/components/MutationsTable.vue'),
    MutationData: () => import('@/components/MutationData.vue'),
  },
  data () {
    return {
      store: store,
      tabView: "Table"
    }
  },
  mounted () {
    console.log('Mutations page mounted!')
    this.loadSections()
  },
  methods: {
    loadSections() { 
      setTimeout(() => { store.render.methods.loadVariantFrequency() }, 100)
      setTimeout(() => { store.render.methods.loadVariantsTable() }, 3000)
    },
    variantSwitchView() {
      store.render.methods.variantSwitchView(this.tabView)
    }
  }
}
</script>

<style>
.section-header {
  font-family: 'Hammersmith One', sans-serif;
  font-size: 2em;
  padding: 20px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.plot-header {
  font-family: 'Hammersmith One', sans-serif;
  font-size: 1.4em;
  padding: 20px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.variant-tab-view .el-radio-button span.el-radio-button__inner {
  font-size: 1.5rem;
  font-weight: bold;
}

</style>
